import { Cookies } from 'react-cookie';
import { checkEnvironment } from 'ui-common/src/lib/utils';
import CookieService from './CookieService';
import SessionStorageService from './SessionStorageService';
import {
  ACCESS_TOKEN,
  APP_CONSTANTS,
  CCSRF_TOKEN,
  FIRST_NAME,
  INGRESSCOOKIE,
  LOCALE,
  MICRO_APP,
  MS_REDIRECT_URL,
  REFRESH_TOKEN,
  TOKEN_TYPE,
  USER_KEY,
  USER_NAME,
  CONSULT_WARN,
  CONSULT_POPOVER,
  STORED_TIME,
  IS_ISPM_INTRO_VIEWED,
  USER_SESSION,
} from '../constants';
import { logoutAction } from './LoginActions';
import { HideLoader } from './Loading-actions';

const cookies = new Cookies();

function isLeftNavGen2Enabled() {
  try {
    return parseInt(window.localStorage.getItem('leftNavGen2'), 10) > 0;
  } catch (_) {
    return false;
  }
}

const common = {
  clearSessionStorage: function () {
    SessionStorageService.remove(MICRO_APP);
    SessionStorageService.remove(APP_CONSTANTS);
    SessionStorageService.remove(IS_ISPM_INTRO_VIEWED);
  },

  dispatchActions: function (dispatch) {
    dispatch(logoutAction());
    dispatch(HideLoader());
  },
};

const gen1 = {
  ...common,

  clearCookies: function () {
    cookies.remove(ACCESS_TOKEN, { path: '/' });
    cookies.remove(REFRESH_TOKEN, { path: '/' });
    cookies.remove(TOKEN_TYPE, { path: '/' });
    cookies.remove(MS_REDIRECT_URL, { path: '/' });
    cookies.remove(USER_NAME, { path: '/' });
    cookies.remove(USER_KEY, { path: '/' });
    cookies.remove(FIRST_NAME, { path: '/' });
  },

  clearLocalStorage: function () {
    localStorage.removeItem(MICRO_APP);
    localStorage.removeItem(LOCALE);
    localStorage.removeItem(STORED_TIME);
    localStorage.removeItem('cc');
  },
};

const gen2 = {
  ...common,

  clearCookies: function () {
    // Removing session cookies
    CookieService.remove(ACCESS_TOKEN, true);
    CookieService.remove(CCSRF_TOKEN, true);
    CookieService.remove(INGRESSCOOKIE, true);
    CookieService.remove(USER_NAME, true);
    CookieService.remove(TOKEN_TYPE, true);
    CookieService.remove(USER_SESSION, true);

    // Removing cookies with maxAge
    CookieService.remove(ACCESS_TOKEN);
    CookieService.remove(REFRESH_TOKEN);
    CookieService.remove(TOKEN_TYPE);
    CookieService.remove(MS_REDIRECT_URL);
    CookieService.remove(USER_NAME);
    CookieService.remove(USER_KEY);
    CookieService.remove(FIRST_NAME);
  },

  clearLocalStorage: function () {
    localStorage.removeItem(MICRO_APP);
    localStorage.removeItem(LOCALE);
    localStorage.removeItem(STORED_TIME);
    localStorage.removeItem(CONSULT_WARN);
    localStorage.removeItem(CONSULT_POPOVER);
    localStorage.removeItem('cc');
  },
};

export const LogoutTrigger = {
  userInitiated: 'LogoutTrigger.userInitiated',
  sessionTimeout: 'LogoutTrigger.sessionTimeout',
  fetchIntecept: 'LogoutTrigger.fetchIntercept',
};

export function logout(logoutTrigger) {
  const dispatch = window.store.dispatch;

  const util = isLeftNavGen2Enabled() ? gen2 : gen1;

  util.dispatchActions(dispatch);
  util.clearCookies();
  util.clearLocalStorage();
  util.clearSessionStorage();

  if (logoutTrigger === LogoutTrigger.fetchIntecept) {
    let logoutPath = '/ECM/logout/clearSession';

    if (window.location.hostname === 'localhost' && !checkEnvironment().SSO_LOGIN) {
      logoutPath = '/login';
    } else if (checkEnvironment().SSO_LOGIN === true) {
      // if sso login, we dont fetch new access token. we redirect to IDP login page.
      const { SSO_LOGIN_URL, CALLBACK_URL } = checkEnvironment();
      logoutPath = `//${SSO_LOGIN_URL}?url=/request/requestHome&callbackurl=${CALLBACK_URL}`;
    }

    window.location.href = logoutPath;
  } else if (logoutTrigger === LogoutTrigger.sessionTimeout) {
    window.location.href = '/ECMv6/sessionTimeout';
  } else {
    const state = store.getState();

    // Default path, but prefer path from BE
    let path = '/ECM/logout/init';

    if (state) {
      const menuList = state.profile?.menuList ?? [];
      const logoutMenu = menuList.find((menu) => menu.id === 'logout');
      if (logoutMenu && logoutMenu.link) {
        path = logoutMenu.link;
      }
    }

    window.location.href = path;
  }
}
